import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReferralImg from '@src/assets/images/referral-reward-vi.svg';
import ReferralImgEn from '@src/assets/images/referral-reward-en.svg';
import sanitizeHtml from 'sanitize-html';
import { StyledReferralIntroSection } from './index.style';

const ReferralIntro = () => {
  const { t, i18n } = useTranslation();
  const isVietnamese = i18n.language === 'vi';
  return (
    <StyledReferralIntroSection>
      <div className="intro-container">
        <div className="intro-image">
          <img
            src={isVietnamese ? ReferralImg : ReferralImgEn}
            className="referral-img"
            alt="referral"
          />
        </div>
        <div className="intro-content">
          <div className="intro-title-container">
            <Typography
              className="intro-title"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(t('referralIntroTitle'), {
                  allowedTags: ['br'],
                }),
              }}
            />
          </div>
          <Typography className="intro-description">
            {t('referralIntroDesc')}
          </Typography>
        </div>
      </div>
    </StyledReferralIntroSection>
  );
};

export default ReferralIntro;
